import { useState } from 'react';
import { ListItem } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

interface CollapsibleListProps {
    title: string;
    items?: any[];
    description?: string
}

export function CollapsibleList ({ title, items, description }: CollapsibleListProps) {
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(!open)
  }
  return (
        <>
            <ListItem onClick={handleClick}>
                <ListItemText primary={title} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
                in={open}
                timeout="auto"
                unmountOnExit
            >
              <List disablePadding>
                {items && (
                  items.map(item => {
                    return (
                        <ListItem key={item.title}>
                            <ListItemText key={item.title} primary={`${item.title}: ${item.value}`} />
                        </ListItem>
                    )
                  }))}
                  {description && (
                    <ListItem>
                      <ListItemText primary={<pre style={{ whiteSpace: 'pre-wrap' }}>{description}</pre>} />
                    </ListItem>
                  )}
              </List>
              
            </Collapse>
            <Divider />
        </>
  )
}
